import { graphql } from "@/lib/gql/__generated__";

export const PlanStock_StockManagement_Query = graphql(/* GraphQL */ `
	query PlanStock_StockManagement($hotelID: ID!, $startDt: String!, $endDt: String!) {
		planStock(hotelID: $hotelID, startDt: $startDt, endDt: $endDt) {
			id
			hotelID
			headers {
				date
				weekday
			}
			items {
				planID
				name
				isInSale
				isDayTrip
				isSecret
				stocks {
					date
					isAvailable
					isEditable
					remainNum
					soldNum
				}
			}
		}
	}
`);
